.widget {
  height: calc(54px - 2 * var(--spacer-1));
  padding: var(--spacer-1) 0;
  background-color: var(--theme-button);
  border-radius: var(--Common--border-radius);
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: stretch;
  justify-content: center;
}

.timer {
  min-width: 100px;
}

.separated {
  > :not(:last-child, .noSeparator) {
    border-right: 1px solid var(--theme-primary-border);
  }
}

.sqicon {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--Common--border-radius);
}

.green {
  background-color: var(--theme-green-background);
  color: var(--theme-green-text);
}

.fistToFiveButtons {
  min-width: 300px;
}
